@if (svg$ | async; as svg) {
  <a
    class="navigation-item"
    matTooltipPosition="right"
    tabindex="0"
    [class.active]="navigationItem.isActive"
    [matTooltip]="
      'dashboardOverview.navigation.' + navigationItem.label + '.label'
        | transloco
    "
    (click)="clicked.emit()"
  >
    <div [innerHTML]="svg | bypassSecurityHtml"></div>
  </a>
}
